// components/decisions.js
import React, { useEffect, useState } from "react";
import {
  Typography,
  Container,
  Box,
  CircularProgress,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import "../App.css";

function Decisions() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadPosts() {
      try {
        const res = await fetch("/api/post/");
        if (!res.ok) {
          throw new Error("Fehler beim Laden der Beiträge");
        }
        const data = await res.json();
        setPosts(data);
      } catch (err) {
        setError(err.message || "Unbekannter Fehler");
      } finally {
        setLoading(false);
      }
    }

    loadPosts();
  }, []);

  return (
    <div className="App">
      <main>
        <Container maxWidth="md" className="container serviceContainer">
          <Typography variant="h1" className="sectionTitle">
            Entscheidungen
          </Typography>

          {loading && <CircularProgress />}

          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}

          {!loading &&
            !error &&
            posts.map((post) => (
              <Box key={post.id} sx={{ mt: 4 }}>
                <Typography variant="h2" className="sectionTitle3 marginTop">
                  {post.title}
                </Typography>
                <Typography variant="body1" className="sectionText">
                  {post.description}
                </Typography>

                <Button
                  component={Link}
                  to={`/article/${post.url}`} // wichtig: gleicher Pfad wie in App.js
                  sx={{ mt: 2 }}
                  className="btnSecondary"
                >
                  Weiterlesen
                </Button>
              </Box>
            ))}
        </Container>
      </main>
    </div>
  );
}

export default Decisions;
